import React from "react";
import { Helmet } from "react-helmet";
import "./Socials.css";

const images = [
    {
        url: require('../../assets/imgs/socials/lady-on-phone.jpg'),
        alt: "Social Media Marketing Concept"
    },
    {
        url: require('../../assets/imgs/socials/social-media.jpg'),
        alt: "Creative Social Media Strategy"
    },
    {
        url: require('../../assets/imgs/socials/social-media-interaction.jpg'),
        alt: "Social Media Icons"
    }
];

export default function Socials() {
    return (
        <>
            <Helmet>
                <title>Social Media Add-On Services | AptoWebsites</title>
                <meta name="description" content="Boost your real estate brand with professional social media management and content creation from AptoWebsites. Add-on services for agents and brokerages." />
                <meta name="keywords" content="social media, real estate marketing, content creation, social media management, AptoWebsites" />
                <meta property="og:title" content="Social Media Add-On Services | AptoWebsites" />
                <meta property="og:description" content="Boost your real estate brand with professional social media management and content creation from AptoWebsites." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/socials" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/socials" />
            </Helmet>
            <div className="socials-page-container">
                <header className="socials-header">
                    <h1>Social Media Add-On Services</h1>
                    <p>
                        Boost your online presence with our professional social media management and content creation services.
                    </p>
                </header>
                <section className="socials-features">
                    <div className="socials-feature">
                        <img src={images[0].url} alt={images[0].alt} className="socials-img" />
                        <div>
                            <h2>Professional Social Media Management</h2>
                            <p>
                                We handle your Facebook, Instagram, LinkedIn, and more. Consistent posting, engagement, and brand growth, so you can focus on your business.
                            </p>
                        </div>
                    </div>
                    <div className="socials-feature reverse">
                        <img src={images[1].url} alt={images[1].alt} className="socials-img" />
                        <div>
                            <h2>Custom Content Creation</h2>
                            <p>
                                Our creative team designs eye-catching graphics, writes compelling copy, and schedules posts to maximize your reach and engagement.
                            </p>
                        </div>
                    </div>
                    <div className="socials-feature">
                        <img src={images[2].url} alt={images[2].alt} className="socials-img" />
                        <div>
                            <h2>Analytics & Reporting</h2>
                            <p>
                                Receive monthly reports on your social performance, growth, and ROI. We help you understand what works and how to improve.
                            </p>
                        </div>
                    </div>
                </section>
                <section className="socials-cta">
                    <h2>Ready to grow your brand?</h2>
                    <p>
                        Purchase our social media services for a complete digital marketing solution.
                    </p>
                    <a href="/pricing" className="socials-contact-btn">Pricing</a>
                </section>
            </div>
        </>
    );
}
